export const validateEmail = (value: string) => {
    const pattern = /.+@[^@]+\.[^@]{2,}$/;
    return pattern.test(value);
}

export const validateUrl = (value: string) => {
    const pattern = /(http(s):\/\/.)[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)$/;
    return pattern.test(value)
}